import React, { useState } from "react";
import { getApi } from '../../api/endpoints';
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants';
import ListingPageComponent from '../../components/ListingPageComponent';
import FiltersPartial from './FiltersPartial.js';
import { updateQueryParams, selectQueryParams } from "../../ui/customerListingReducer";
import { useSelector } from "react-redux";

const Index = () => {
  const [filtersModel, setFiltersModel] = useState(useSelector(selectQueryParams)["filters"]);
  const defaultHeaderConfig = { disableSort: false };

  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'From User',
      value: (row) => {
        return <div className="d-block">
          <div>
            {row.from_user_name || "Admin"}
          </div>
          <div>
            ({row.from_user_id})
          </div>
        </div>
      },
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'To User',
      value: (row) => {
        return <div className="d-block">
          <div>
            {row.to_user_name}
          </div>
          <div>
            ({row.to_user_id})
          </div>
        </div>
      },
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'From User --> To User',
      value: (row) => {
        return `${row.from_users_type_name} --> ${row.to_users_type_name}`;
      },
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Cashback for',
      attr: 'cashback_for',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Status',
      attr: 'status',
      disableSort: true
    }, {
      ...defaultHeaderConfig,
      label: 'Created at',
      attr: 'created_at',
    }
  ]

  return <ListingPageComponent
    key={PAGES.WalletCashbacksListingPage.name}
    uiPage={uiManager.getUiPage(PAGES.WalletCashbacksListingPage.name)}
    breadcrumbs={[{ label: 'Home', url: '/dashboard' }, { label: 'Wallet Cashbacks' }]}
    listingMutation={getApi('walletCashbacks')}
    className="wallet-cashbacks-listing-page"
    contentHeading="Wallet Cashbacks List - Results"
    headers={headers}
    recordsKey="wallet_cashbacks"
    filtersModel={filtersModel}
    filters={
      <FiltersPartial
        filtersModel={filtersModel}
        setFiltersModel={setFiltersModel}
      />
    }
    searchBy={['ID', 'From User (Name)', 'To User (Name)']}
  />
};

export default Index;
